<template>
  <div class="index_answer">
    <Audior ref="audioer" @audioResult="audioResult"></Audior>
    <div class="index_message_box" ref="middle">
      <div class="index_message_answer" v-if="!messages || messages==null || messages.length<=0">
        <div class="index_message_box_text">
          <div v-html="emptyTitle"></div>
        </div>
      </div>
      <div v-for="(item,index) in messages" :key="index" :class="item.self ? `index_message_question` : `index_message_answer`">
        <div v-if="!item.qtype || item.qtype===0">
          <div class="index_message_box_text">
            <div style="float:left;color:red;"><i class="el-icon-warning" v-if="item.failed" @click="reAnswer(item.message)"></i></div>
            <div v-html="item.message"></div>
            <p style="margin:0;padding:0;" v-if="item.atype>=7 && item.atype<=9 && item.location_data">
              <i class="el-icon-s-promotion" style="color:green;cursor:pointer;" v-if="!item.self" @click="showMap(item)">点击查看地图 ☜</i>
            </p>
            <p style="margin:0;padding:0;" v-if="item.atype>=7 && item.atype<=9 && item.location_data">&nbsp;</p>
            <p style="margin:0;padding:0;">
              <i class="el-icon-copy-document" style="color:grey;cursor:pointer;" v-if="!item.self" v-clipboard:copy="item.message" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">点击复制答案 ☜</i>
            </p>
          </div>
          <div class="index_message_box_link" v-if="item.photo_link && item.photo_link!==''">
            <el-image :src="item.photo_link"/>
          </div>
          <div class="index_message_box_link" v-if="item.link && item.link!==''">
            <p style="margin:0;padding:0;">&nbsp;</p>
            <el-link type="primary" size="mini" @click="openmp(item)">{{ item.link_describe }}<i class="el-icon-view el-icon--right"></i><i class="el-icon-link el-icon--right"></i></el-link>
            <p style="margin:0;padding:0;">&nbsp;</p>
          </div>
          <div v-if="!item.self && item.keyword && item.keyword!==''">
              <p style="margin:0;padding:.1rem;cursor:pointer;" v-for="(su,key) in suffixs" :key="key" v-if="item.atype !== key+1" @click="reAnswer(item.keyword + su)"><span style="color:orange;">{{item.keyword}}</span> {{su}} ☜</p>
          </div>
        </div>
        <div v-if="item.qtype && item.qtype===1">
          <audio ref="audioPlayer" @ended="audioEnd(index)">
            <source :src="audioPath" type="audio/wav"/>
          </audio>
          <div>
            <i :class="item.playing ? `el-icon-video-pause`:`el-icon-video-play`" @click="playOrPauseAudio(index)" style="height:3vh;line-height:3vh;text-align:center;width:1.5rem;font-size:1rem;float:left;"></i>
            <div v-if="!item.parsed" style="height:3vh;line-height:3vh;width:8rem;float:left;"> 语音解析中 <i class="el-icon-loading"></i></div>
            <div v-if="item.parsed" v-html="item.message"></div>
          </div>
        </div>
      </div>
      <div class="index_message_answer" v-if="loading">
        <div class="index_message_box_text">问题思考中<span style="color:grey;">{{thinking}}</span></div>
      </div>
      <div class="index_message_answer" v-if="!accessValid">
        <div class="index_message_box_text">提问次数已用尽<span style="color:orange;" @click="payAccess">[购买次数]</span></div>
      </div>
    </div>
    <div class="index_input_box">
      <i class="el-icon-loading index_answer_microphone" v-if="microphone && (loading || parsing)"></i>
      <i class="el-icon-microphone index_answer_microphone" @click="openAudio" v-if="microphone && !loading && !parsing"></i>
      <el-input size="small" v-model="question" :placeholder="parsing ? '语音解析中...' : '提问：Ever given的船舶基本信息'" :disabled="loading || parsing" :style="`margin-left:2%;width:`+(microphone ? '65%' : '75%')+`;`" @keyup.enter.native="submitQuestion"></el-input>
      <el-button @click="submitQuestion" clearable type="primary" size="small" :disabled="loading || parsing" style="width:3.5rem;text-align:center;margin-left:2%;">提交</el-button>
    </div>
    <el-dialog width="100%" center :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" :title="titles[message['atype']]" :visible.sync="dialogVisible">
      <div class="map">
        <div class="map-container" id="maps"></div>
      </div>
      <span slot="footer">
        <el-button type="primary" size="small" @click="closeMap">关闭返回</el-button>
      </span>
    </el-dialog>
    <dragButton :y="20" :x="10" :width="36" :height="36" :right="true" @clicked="toUser">
      <div class="answer_drag"><i class="el-icon-user-solid"></i></div>
    </dragButton>
    <dragButton :y="70" :x="10" :width="36" :height="36" :right="true" @clicked="toSign">
      <div class="answer_drag"><i class="el-icon-success"></i></div>
    </dragButton>
    <dragButton :y="120" :x="10" :width="36" :height="36" :right="true" @clicked="clearMessages">
      <div class="answer_drag"><i class="el-icon-delete-solid"></i></div>
    </dragButton>
    <dragButton :y="170" :x="10" :width="36" :height="36" :right="true" @clicked="toInterview" v-if="interview">
      <div class="answer_drag"><i class="el-icon-video-camera"></i></div>
    </dragButton>
  </div>
</template>

<script>
  import { openaiQuestion,userAccessValid,searchAccessGoods,payOrderGet,payOrderCheck } from "../../api/api";
  import Xunfei from '../../util/xunfei'
  import { wechatPayAccessGoods } from '../../util/pay'
  import { getJsonStorage,setJsonStorage } from "../../util/storage";
  import { getBrowserType } from "../../util/common"
  import 'leaflet/dist/leaflet.css'
  import L from 'leaflet'
  import 'leaflet-semicircle'
  import 'leaflet-rotatedmarker'
  import dragButton from '../dragButton'
  import Audior from '../audior'

  export default {
    name: "IndexAnswer",
    components:{
      dragButton,
      Audior
    },
    data() {
      return {
        audioPath:null,
        question: null,
        loading:false,
        parsing:false,
        thinking:'',
        messages:[],
        message:{},
        dialogVisible:false,
        map: null,
        layers: null,
        shipMarker: null,
        vesselPoints:[],
        vesselPaths:[],
        vesselPointsGroup: null,
        vesselPathsGroup: null,
        titles:{7:"船舶位置",8:"历史轨迹",9:"停靠港口"},
        accessValid:true,
        centerDialogVisible:false,
        emptyTitle:'',
        suffixs:["船舶基本信息","船舶估值","有哪些风险","有哪些违规","有哪些PSC检查扣留记录","发生过哪些事故","现在在哪里","过去7天历史轨迹","过去30天停靠港口","船舶制裁情况"],
        user:getJsonStorage('openai_user'),
        privileges:getJsonStorage('openai_privileges'),
        microphone:false,
        interview:false
      }
    },
    mounted(){
      payOrderCheck();
      let smessage = "";
      for(let s in this.suffixs){
        smessage += "<br/><span style='color:orange;'>Ever given</span>"+this.suffixs[s];
      }
      this.emptyTitle = "您可以提出如下船舶相关问题："+smessage;
      let messages = getJsonStorage('openai_aq_history');
      if(messages!=null && messages !== '' && messages !== '[]'){
        this.messages = JSON.parse(messages);
      }
      setTimeout(()=>{
        this.privileges = getJsonStorage('openai_privileges');
        if(this.privileges!=null && this.privileges.permissions != null){
          for(let p in this.privileges.permissions){
            if(this.privileges.permissions[p].permission_value === 'WXMP_microphone'){
              this.microphone = true;
            }
            if(this.privileges.permissions[p].permission_value === 'WXMP_interview'){
              this.interview = true;
            }
          }
        }
      },600);
      let thinkpoint = 0;
      setInterval(()=>{
        thinkpoint++;
        if(thinkpoint===6){
          thinkpoint = 0;
          this.thinking = '·';
        }
        this.thinking += '·';
      },500);
    },
    methods: {
      reAnswer(message){
        this.question = message;
        this.submitQuestion();
      },
      submitQuestion(){
        if(this.question==null || this.question.replace(/[\r\n\s]*/ig,'')===''){
          this.$message.warning("请输入问题");
          return;
        }
        if(this.question.length > 100){
          this.$message.warning("提问字数不能超过100字");
          return;
        }
        let quetions = JSON.parse(JSON.stringify(this.question));
        this.messages.push({'self':true,'message':quetions,'failed':false});
        this.question = null;
        this.loading = true;
        setTimeout(()=>{
          let middle = this.$refs['middle'];
          middle.scrollTop = middle.scrollHeight;
        },600);
        this.checkQuestion(quetions);
      },
      checkQuestion(quetions){
        userAccessValid('/datacenter/standard/gemini/v1/conversation',quetions).then(res => {
          if(res && res.status === 0){
            if(res.data.valid || res.data.count > 0){
              openaiQuestion(quetions,-1).then(res => {
                if(res && res.status===0){
                  let data = JSON.parse(JSON.stringify(res.data));
                  data.message = data.message.replace(/\n/ig,'<br/>');
                  this.messages.push(data);
                  setJsonStorage('openai_aq_history',JSON.stringify(this.messages));
                }else{
                  this.message.pop();
                  this.messages.push({'self':true,'message':quetions,'qtype':0,'failed':true});
                }
              }).catch(e => {
                this.messages.pop();
                this.messages.push({'self':true,'message':quetions,'qtype':0,'failed':true});
              }).finally(e => {
                this.loading = false;
                this.accessValid = true;
                setTimeout(()=>{
                  let middle = this.$refs['middle'];
                  middle.scrollTop = middle.scrollHeight;
                },600);
              });
            }else{
              this.messages.pop();
              this.messages.push({'self':true,'message':quetions,'qtype':0,'failed':true});
              this.accessValid = false;
              this.loading = false;
            }
          }else{
            this.messages.pop();
            this.messages.push({'self':true,'message':quetions,'qtype':0,'failed':true});
            this.loading = false;
          }
        });
      },
      freeQuestion(quetions){
        openaiQuestion(quetions,-1).then(res => {
          if(res && res.status===0){
            let data = JSON.parse(JSON.stringify(res.data));
            data.message = data.message.replace(/\n/ig,'<br/>');
            this.messages.push(data);
            setJsonStorage('openai_aq_history',JSON.stringify(this.messages));
          }else{
            this.message.pop();
            this.messages.push({'self':true,'message':quetions,'qtype':0,'failed':true});
          }
        }).catch(e => {
          this.messages.pop();
          this.messages.push({'self':true,'message':quetions,'qtype':0,'failed':true});
        }).finally(e => {
          this.loading = false;
          this.accessValid = true;
          setTimeout(()=>{
            let middle = this.$refs['middle'];
            middle.scrollTop = middle.scrollHeight;
          },600);
        });
      },
      openmp(item){
        if(getBrowserType()===1){
          let url = (item['mmsi'] && item['mmsi']) > 0 ? '/pages/index/openmp?mmsi='+item['mmsi'] : '/pages/index/openmp';
          this.$wx.miniProgram.navigateTo({url:url});
        }else{
          let a = document.createElement("a");
          a.href = item.url;
          a.target = '_blank';
          a.click();
        }
      },
      clearMessages(){
        this.$confirm('操作不可恢复,确认清空?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'danger',
          center:true
        }).then(() => {
          this.messages = [];
          setJsonStorage('openai_aq_history','[]');
        }).catch(() => {});
      },
      payAccess(){
        searchAccessGoods('/datacenter/standard/gemini/v1/conversation').then(res => {
          if(res && res.status === 0 && res.data){
            this.$confirm((res.data.price * res.data.discount / 10)+'￥ = '+res.data.counts+'次','购买问答次数',{
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning',
              center:true
            }).then(() => {
              wechatPayAccessGoods(res.data.access_goods_id,(pres) => {
                switch(pres.err_msg){
                  case 'get_brand_wcpay_request:ok':
                    this.accessValid = true;
                    this.$message.success('购买成功');
                    if(pres.order_id) payOrderGet(pres.order_id);
                    break;
                  case 'get_brand_wcpay_request:cancel':
                    this.$message.warning('支付已取消');
                    break;
                  case 'get_brand_wcpay_request:fail':
                    this.$message.error('支付失败');
                    break;
                  default:
                    this.$message.error(pres.err_msg);
                    break;
                }
              });
            }).catch(() => {});
          }else{
            alert(res.message || res.msg);
          }
        });
      },
      audioResult(data){
        this.parsing = true;
        new Xunfei(data.path).then(res => {
          this.question = res;
          this.parsing = false;
        }).catch(e => {
          this.$message.error(e);
          this.parsing = false;
        });
      },
      playOrPauseAudio(index){
        let player = this.$refs.audioPlayer;
        if(!player.paused) player = player[0];
        if(player){
          if(this.messages[index]['playing']){
            player.pause();
            this.messages[index]['playing'] = false;
            this.audioPath = null;
          }else{
            this.messages[index]['playing'] = true;
            this.audioPath = this.messages[index]['path'];
            player.load();
            player.play();
          }
        }
      },
      audioEnd(index){
        let player = this.$refs.audioPlayer;
        if(!player.paused) player = player[0];
        if(player){
          player.pause();
          this.messages[index]['playing'] = false;
          this.audioPath = null;
        }
      },
      onCopySuccess(){
        this.$message.success('复制成功');
      },
      onCopyError(){
        this.$message.error('复制失败');
      },
      toUser(){
        this.$router.push('/user/detail');
      },
      toSign(){
        this.$router.push('/index/sign');
      },
      toInterview(){
        this.$router.push('/interview/list');
      },
      openAudio(){
        this.$refs.audioer.openAudior();
      },
      showMap(item){
        this.message = item;
        this.dialogVisible = true;
        this.$nextTick(()=>{
          this.getMap();
          switch(this.message.atype){
            case 7:
              this.getShip();
              break;
            case 8:
              this.getVessel();
              break;
            case 9:
              this.getPorts();
              break;
            default:
              break;
          }
        })
      },
      getMap(){
        if(this.map == null){
          const maxBounds = new L.LatLngBounds(new L.LatLng(-80, -360), new L.LatLng(80, 360));
          this.map = L.map('maps', {
            minZoom: 3,
            maxZoom: 8,
            center: [29.6, 106.9],
            zoom: 3,
            maxBounds: maxBounds,
            maxNativeZoom: 8,
            noWarp: true,
            zoomControl: false,
            attributionControl: false,
            latLngsToCoords: true,
            crs: L.CRS.EPSG3857
          }).fitWorld().setView([29.6, 106.9], 3);
        }
        this.layers = L.tileLayer("https://marine-tile.anlantech.cn/{z}/{y}/{x}.png", {
          minZoom: 3,
          maxZoom: 8,
          maxNativeZoom: 8,
          zoom: 3
        }).addTo(this.map);
      },
      closeMap(){
        if(this.shipMarker!=null){
          this.map.removeLayer(this.shipMarker);
          this.shipMarker = null;
        }
        if(this.vesselPointsGroup != null){
          this.map.removeLayer(this.vesselPointsGroup);
          this.vesselPointsGroup = null;
          this.vesselPoints = [];
        }
        if(this.vesselPathsGroup != null){
          this.map.removeLayer(this.vesselPathsGroup);
          this.vesselPathsGroup = null;
          this.vesselPaths = [];
        }
        this.dialogVisible = false;
      },
      getShip(){
        this.shipMarker = L.marker({lat:this.message.location_data.lat/600000,lng:this.message.location_data.lon/600000},{
          icon:L.icon({
            title:this.message.keyword,
            iconUrl: require('../../../static/imgs/posTap.png'),
            iconSize: [12,24]
          }),
          rotationAngle: this.message.location_data.hdg ? this.message.location_data.hdg/10 : (this.message.location_data.cog ? this.message.location_data.cog/10 : 0)
        });
        this.shipMarker.bindPopup(this.message.keyword);
        this.shipMarker.addTo(this.map);
        this.map.setView({lat:this.message.location_data.lat/600000,lng:this.message.location_data.lon/600000},4);
      },
      getVessel(){
        if(this.vesselPointsGroup != null){
          this.map.removeLayer(this.vesselPointsGroup);
          this.vesselPointsGroup = null;
          this.vesselPoints = [];
        }
        if(this.vesselPathsGroup != null){
          this.map.removeLayer(this.vesselPathsGroup);
          this.vesselPathsGroup = null;
          this.vesselPaths = [];
        }
        let latlngs = [];
        if(this.message.location_data && this.message.location_data.length>0){
          for(let o in this.message.location_data){
            let title = new Date(this.message.location_data[o].utc * 1000).toLocaleString() + '<br/>航速:' + (this.message.location_data[o].sog/514.444).toFixed(1) + '节<br/>经纬度:'+Math.abs(this.message.location_data[o].lon/1000000).toFixed(6)+(this.message.location_data[o].lon>=0?'E':'W')+','+Math.abs(this.message.location_data[o].lat/1000000).toFixed(6)+(this.message.location_data[o].lat>=0?'N':'S');
            let vmarker = L.marker({lat:(this.message.location_data[o].lat/1000000).toFixed(6),lng:(this.message.location_data[o].lon/1000000).toFixed(6)},{
              icon:L.icon({
                iconUrl: require('../../../static/imgs/pointB.png'),
                iconSize: [6,6]
              })
            });
            vmarker.bindPopup(title);
            this.vesselPoints.push(vmarker);
            latlngs.push([(this.message.location_data[o].lat/1000000).toFixed(6),(this.message.location_data[o].lon/1000000).toFixed(6)]);
          }
          this.vesselPaths.push(L.polyline(latlngs, {color:'rgba(64,157,255,0.7)',dashArray: [3,6]}));
          this.vesselPointsGroup = L.layerGroup(this.vesselPoints);
          this.vesselPathsGroup = L.layerGroup(this.vesselPaths);
          this.vesselPointsGroup.addTo(this.map);
          this.vesselPathsGroup.addTo(this.map);
          this.map.setView([this.message.location_data[0].lat/1000000,this.message.location_data[0].lon/1000000],5);
        }
      },
      getPorts(){
        if(this.vesselPointsGroup != null){
          this.map.removeLayer(this.vesselPointsGroup);
          this.vesselPointsGroup = null;
          this.vesselPoints = [];
        }
        if(this.message.location_data && this.message.location_data.length>0){
          for(let o in this.message.location_data){
            let title = this.message.location_data[o].port_zh + ' ('+(this.message.location_data[o].during/3600).toFixed(1)+'小时)<br/>靠港:'+this.message.location_data[o].start+'<br/>离港:'+this.message.location_data[o].end;
            let vmarker = L.marker({lat:(this.message.location_data[o].lat).toFixed(6),lng:(this.message.location_data[o].lon).toFixed(6)},{
              icon:L.icon({
                iconUrl: require('../../../static/imgs/port.png'),
                iconSize: [18,18]
              })
            });
            vmarker.bindPopup(title);
            this.vesselPoints.push(vmarker);
          }
          this.vesselPointsGroup = L.layerGroup(this.vesselPoints);
          this.vesselPointsGroup.addTo(this.map);
          this.map.setView([this.message.location_data[0].lat,this.message.location_data[0].lon],5);
        }
      }
    }
  }
</script>

<style scoped>
  .vdr.active:before {
    outline: none;
  }
  .answer_drag {
    width:36px;
    height:36px;
    line-height:36px;
    border-radius:21px;
    text-align:center;
    font-size:21px;
    background-color:#3a8ee6;
    color:white;
    text-shadow: 2px 1px 1px #1a6eb6;
  }
  .index_answer {
    position:absolute;
    top:6vh;
    left:0;
    width: 100%;
    height: 94vh;
    background-color: #f7f7f7;
    text-shadow: .3px .3px .3px grey;
  }
  .index_message_box {
    width:100%;
    float:left;
    height:82vh;
    overflow-y: scroll;
    overflow-x: inherit;
  }
  .index_message_question {
    width:82%;
    margin-right:2%;
    padding:.5rem;
    font-size:.9rem;
    letter-spacing: .05rem;
    margin-top:2vh;
    float: right;
    background-color:white;
    border-radius:.3rem;
  }
  .index_message_answer {
    width:82%;
    margin-left:2%;
    padding:.5rem;
    font-size:.9rem;
    letter-spacing: .05em;
    margin-top:2vh;
    float: left;
    background-color: #e1eaf1;
    border-radius:.3rem;
  }
  .index_message_box_link {
    font-size:.9rem;
    color:grey;
  }
  .index_message_box_text {
    width:100%;
  }
  .index_input_box {
    position:fixed;
    bottom:0;
    left:0;
    width:100%;
    height:10vh;
  }
  .index_answer_microphone {
    margin-left:2%;
    height:3vh;
    line-height:3vh;
    width:3vh;
    font-size:.9rem;
    color:#3a8ee6;
    border:1px solid #3a8ee6;
    border-radius:1rem;
    text-align:center;
  }
  .index_answer_head {
    width:94%;
    float:left;
    top:0;
    left:0;
    padding: 0 3%;
    height:3vh;
    line-height:3vh;
    border-bottom:1px solid #ddd;
    font-size:.85rem;
  }
  .index_answer_head_left {
    top:0;
    left:0;
    width:50%;
    float:left;
    text-align:left;
    color: #6cb3ff;
  }
  .index_answer_head_right {
    top:0;
    left:0;
    width:50%;
    float:left;
    text-align:right;
    color: #aaa;
  }
  .map-container {
    width: 100%;
    height: 50vh;
  }
  .map {
    width:100%;
  }
  #maps {
    width:100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/answer.vue